// extracted by mini-css-extract-plugin
module.exports = {"container":"FaceComponent_container__1fAc2","leftEye":"FaceComponent_leftEye__25fQl","rightEye":"FaceComponent_rightEye__ohMXV"};